  (function(){
    var API = window.BB_API;
    var LSK='bb_anon', REFK='bb_ref';
    var MSG = "These aren't normal fan art cards \u2014 thick raised UV, gold foil, textured stock, holo film, blue core. They feel like a pull, not a print.\n\nHere's the drop \ud83d\udc47";
    var st = { anon:null, ref:null, refx:null, credit:0, op:null };   /* opdist: 运营分销归属码；refx: 首触推广码 */

    function uid(){ var a='abcdefghijklmnopqrstuvwxyz0123456789', s='';
      for(var i=0;i<16;i++) s+=a.charAt(Math.floor(Math.random()*a.length)); return s; }
    function ls(k){ try { return localStorage.getItem(k); } catch(e){ return null; } }
    function lss(k,v){ try { localStorage.setItem(k,v); } catch(e){} }
    function ck(k){ var m=document.cookie.match('(^|;)\\s*'+k+'=([^;]+)'); return m?decodeURIComponent(m[2]):null; }
    function setck(k,v,d){ document.cookie=k+'='+encodeURIComponent(v)+';path=/;max-age='+(d*86400)+';samesite=lax'; }
    function toast(t){ var el=document.getElementById('toast'), tx=document.getElementById('toastText');
      if(!el||!tx) return; tx.textContent=t; el.classList.add('on');
      clearTimeout(window.__bbrT); window.__bbrT=setTimeout(function(){ el.classList.remove('on'); },2000); }
    function copyText(t){ if(!t) return;
      if(navigator.clipboard&&navigator.clipboard.writeText){
        navigator.clipboard.writeText(t).then(function(){ toast('Link copied'); },function(){ fb(t); });
      } else fb(t); }
    function fb(t){ var ta=document.createElement('textarea'); ta.value=t; ta.style.position='fixed';
      ta.style.opacity='0'; document.body.appendChild(ta); ta.select();
      try{ document.execCommand('copy'); toast('Link copied'); }catch(e){} document.body.removeChild(ta); }

    function anon(){
      var k = ls(LSK) || ck('bb_anon');
      if(!k){ k=uid(); }
      lss(LSK,k); setck('bb_anon',k,365);
      return k;
    }
    function code(){ return st.anon ? ('BB-' + st.anon.slice(0,6).toUpperCase()) : 'BB-'; }
    /* ONE-TRUTH-20261101：链接里**不写任何折扣码**。全站只有一个折扣（订阅 10%，
       由后端按邮箱判定后落 COLLECTOR5），分享链接只带 ref 做归属。
       FRIEND10 / FRIEND15 那套升级链已于 2026-10-31 全部删除。 */
    /* ATTR-UTM-20261025：分享链接统一带 UTM。
       原因：朋友从分享链接进来，Safari / IG 内置浏览器常把 referrer 抹掉，
       FRIEND10 也不一定打上 ⇒ 订单会掉进「来源未知」，推广效果算不出来。
       带上 utm_source=share 后，Shopify 会把首访 utm 记进 customerJourneySummary，
       企微日报第二层判定（UTM）就能把它归到「分享链接」。
       ⚠️ ref 参数必须留在最前：captureRef() 用 /[?&]ref=([^&]+)/ 取值，后面再挂 & 不影响。 */
    function link(){ return location.origin + '/?ref=' + encodeURIComponent(st.anon) + '&utm_source=share&utm_medium=referral&utm_campaign=friend'; }

    function isIOS(){ return /iPad|iPhone|iPod/.test(navigator.userAgent); }
    function paint(){
      var l=document.getElementById('bbrLink'), m=document.getElementById('bbrMsgBox');
      if(l) l.textContent = st.anon ? link() : '…';
      if(m) m.textContent = st.anon ? (MSG + '\n' + link()) : '';
      var ts=document.querySelectorAll('[data-bbr-link-text]');
      for(var i=0;i<ts.length;i++) ts[i].textContent = st.anon ? link() : '';
      var fs=document.querySelectorAll('[data-bbr-foot]');
      /* REF-BALANCE-ALWAYS-20261023：以前余额 0 时只写「Pays out in credit」，
         买家根本不知道这套机制存在。现在**始终带金额**：
           $0.00 earned · share to start  ←→  $12.40 earned · never expires
         「从没有到有」的心理落差，比「从看不到到看到」大得多。 */
      for(var j=0;j<fs.length;j++) fs[j].textContent = st.credit>0
        ? ("You've earned $" + st.credit.toFixed(2) + " so far \u00b7 never expires")
        : ('$0.00 earned \u00b7 share a link to start');

      // 能直跳 App 的渠道：短信 / WhatsApp / 邮件（IG、TikTok 没有网页分享入口，只能走系统面板）
      if(st.anon){
        var u = encodeURIComponent(link());
        var txt = encodeURIComponent(MSG + ' ' + link());
        var sms = document.getElementById('bbrSms');
        if(sms) sms.href = isIOS() ? ('sms:&body=' + txt) : ('sms:?body=' + txt);
        var wa = document.getElementById('bbrWa');
        if(wa) wa.href = 'https://wa.me/?text=' + txt;
        var ml = document.getElementById('bbrMail');
        if(ml) ml.href = 'mailto:?subject=' + encodeURIComponent("beibelle74 fan art cards")
                        + '&body=' + txt;
        var c3 = document.getElementById('bbrCopy3');
        if(c3) c3.href = '#';
        void u;
      }
    }

    /* 2026-10-29：推广统一到 /pages/rewards。旧面板不再打开 ——
       这里的入口（商品页图标 / 看货器分享 / 顶部信用条）全部改成跳转。 */
    function openSheet(){
      /* SHEET-QUERY-20261030：openSheet 现在是「跳独立推广页」（旧的内联弹层已拆走），
         原来无条件跳 /pages/rewards，把 ?share=1 丢在跳转路上 ⇒
         推广页的 S.pendingShare 读不到，登录回来后「自动弹分享框」永远不弹（一次白点）。
         这里把 share=1 带过去，rewards 页 L689 就会照常消费它。 */
      try {
        window.location.href = '/pages/rewards' + (/(?:[?&])share=1(?:&|$)/.test(location.search) ? '?share=1' : '');
      } catch (e) {}
    }
    function closeSheet(){
      var sc=document.getElementById('bbrScrim'), sh=document.getElementById('bbrSheet');
      if(sc) sc.classList.remove('on'); if(sh) sh.classList.remove('on');
    }
    window.BBRef = { open: openSheet, close: closeSheet, link: link, code: code };

    // 余额：唯一还在调接口的地方，失败就静默（不影响分享）
    function balance(){
      if(!st.anon) return;
      var ctl = window.AbortController ? new AbortController() : null;
      var t = setTimeout(function(){ if(ctl) ctl.abort(); }, 4000);
      fetch(API + '/balance?anon_id=' + encodeURIComponent(st.anon), ctl?{signal:ctl.signal}:{})
        .then(function(r){ return r.json(); })
        .then(function(d){
          clearTimeout(t); if(!d) return;
          st.credit = d.available || 0;
          paint();
          var strip=document.getElementById('bbrStrip');
          if(strip && st.credit>0){
            var amt=document.getElementById('bbrStripAmt');
            if(amt) amt.textContent='$'+st.credit.toFixed(2);
            var go=document.getElementById('bbrStripGo');
            if(go && d.reward_link) go.href=d.reward_link;
            strip.classList.add('on');
          }
        }).catch(function(){ clearTimeout(t); });
    }

    // OPDIST-20261025：op = 运营分销归属码。必须和 ref_id/ref 在**同一个** fetch 钩子里注入，
    // 另起钩子会用自己那份 attributes 把对方的覆盖掉（2026-10-23 实测踩过）。
    function cartAttrs(){ var a={ ref_id: st.anon }; if(st.refx || st.ref) a.ref=st.refx || st.ref; if(st.op) a.op=st.op; return a; }

    // 🔴 主题加车走 fetch('/cart/add.js')，而 Shopify 会用请求里的 attributes 覆盖购物车属性
    //    ⇒ 不带上就会被清空、归属全丢（实测：加一件后 attributes 变 {}）。
    //    所以在 add 请求上自动注入属性，从源头保证不丢。
    (function(){
      if(!window.fetch || window.__bbShim) return;
      window.__bbShim = 1;
      var of = window.fetch;
      window.fetch = function(u, o){
        try{
          var url = (typeof u === 'string') ? u : ((u && u.url) || '');
          if(url.indexOf('/cart/add') > -1 && o && typeof o.body === 'string'){
            var j = JSON.parse(o.body);
            if(j && typeof j === 'object' && !Array.isArray(j)){
              var a = cartAttrs(), k;
              j.attributes = j.attributes || {};
              for(k in a){ if(a[k]) j.attributes[k] = a[k]; }
              o = Object.assign({}, o, { body: JSON.stringify(j) });
            }
          }
        }catch(e){}
        return of.call(window, u, o);
      };
    })();

    // 归属：把自己的匿名 id + 朋友的 ref 写进购物车属性（同源，不依赖外部接口）
    // 读页面购物车角标，判断车是否为空（拿不到就按非空处理，宁可多写一次也别丢归属）
    function cartN(){
      var b=document.querySelector('.cart-btn');
      if(!b) return -1;
      var m=(b.textContent||'').match(/\d+/);
      return m?parseInt(m[0],10):0;
    }
    function tagCart(){
      var attrs = cartAttrs();
      // REGRESS-20261023：空车不写属性。原来每个页面加载都 POST 一次 /cart/update.js，
      // 空车也发 ⇒ 连续逛几页就吃掉 Shopify 的购物车接口配额，实测会把真正的加购打成 429。
      // 归属不会丢：加购时 fetch 钩子会把 ref_id/ref 注入 /cart/add 请求体。
      if(cartN() === 0) return;
      // 🔴 OPDIST-20261025 修：去重键必须含 op，否则「先抓到 ref、后点 op 链接进来」时
      //    会被当成已写过而不重写，购物车里就少了 op（运营业绩直接丢这一单）。
      var _tk = st.anon+':'+(st.ref||'')+':'+(st.op||'');
      try { if(sessionStorage.getItem('bb_tagged') === _tk) return; } catch(e){}
      fetch('/cart/update.js', { method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ attributes: attrs }) })
        .then(function(){ try{ sessionStorage.setItem('bb_tagged', _tk); }catch(e){} })
        .catch(function(){});
    }

    function captureRef(){
      var m = location.search.match(/[?&]ref=([^&]+)/);
      if(m){
        var v = decodeURIComponent(m[1]).replace(/[^A-Za-z0-9_-]/g,'').slice(0,64);
        if(v){ st.ref = v; lss(REFK,v); setck('bb_ref',v,30); }
      }
      if(!st.ref) st.ref = ls(REFK) || ck('bb_ref');

      /* ══ LINKMERGE-20261030 · 首触归因（refx）══════════════════════════
         这就是「一个客户只有一个推广人」的前端那一半：
           · bb_ref（30 天、可被后一个链接覆盖）= 折扣决策用的"最近一次"，一行都不改；
           · bb_refx（365 天、**只在空值时写、永不覆盖**）= 真正写进订单属性 ref 的那个。
         为什么必须分开：折扣是"这一次买得便宜"，归属是"这个人第一次是谁带来的"。
         合成一个 cookie 就必然打架 —— 30 天太短（跨月复购会丢），可覆盖又让后推的人
         抢走前一个人的客户。分开之后，两件事各自正确。
         ⚠️ 服务端的权威仍然是 ERP 的 op_first_touch：客户换设备/清 cookie 时这里会丢，
            丢了他也照样能在服务端被算回原推广人。
         ⚠️ 老访客迁移：如果已经有 bb_ref 但没有 bb_refx，就把现有 bb_ref 当首触。
            宁可继承一个"最近一次"，也好过让老客户在升级当天凭空失去归属。 */
      var REFX='bb_refx';
      st.refx = ls(REFX) || ck(REFX);
      if(!st.refx && st.ref){ st.refx = st.ref; lss(REFX, st.refx); setck(REFX, st.refx, 365); }
    }

    /* 🔴 OPDIST-20261025 运营分销归因（侯哥定：运营只发链接，不给客户填码的负担）
       ------------------------------------------------------------------
       运营专属链接形如 https://beibelle74.com/?op=OP01（任意页带 ?op= 都算）。
       取到后落三处：cookie bb_op（**365 天**）/ localStorage / 加车属性（走上面的 fetch 钩子）。
       订单侧落 customAttributes.op=OP01 → ERP「运营分销」按订单归属；同一客户首单锁定后永久归属。
       ⚠️ 不要改成 30 天：运营种草到成交常跨月，窗口短了会把业绩判给公司自然流量。 */
    var OPK='bb_op';
    function captureOp(){
      var m = location.search.match(/[?&]op=([A-Za-z0-9_-]{1,24})/);
      var v = m ? m[1].toUpperCase() : null;
      /* LINKMERGE-20261030 · 首触语义（原来这里是 last-touch：后点的链接直接覆盖 365 天 cookie）
         改法：**只有还没归属过才写**；已有值就只刷新时间戳 bb_op_at，绝不改归属人。
         为什么改：侯哥定的口径是「一个客户只归一个人，先来的算」。前端不拦的话，
         客户先后点了运营 A、运营 B 的链接，下单时带的就是 B —— A 白推。
         服务端 op_customers 仍是权威（它按首单锁定），这里只是让前端别主动帮倒忙。
         ⚠️ 想让某人重新拿客户：删他的 bb_op/bb_op_at（或换浏览器），或后台人工改归属。 */
      st.op = ls(OPK) || ck('bb_op');
      if(v && !st.op){ st.op = v; lss(OPK, v); setck('bb_op', v, 365); }
      if(st.op){ lss('bb_op_at', String(Date.now())); }
    }

    // REGRESS-20261023：桌面/键盘用户习惯按 ESC 关面板，原来只有点遮罩能关
    document.addEventListener('keydown', function(e){
      if(e.key!=='Escape' && e.keyCode!==27) return;
      var sh=document.getElementById('bbrSheet');
      if(sh && sh.classList.contains('on')) closeSheet();
    });

    document.addEventListener('click', function(e){
      var t=e.target;
      /* 2026-10-29：推广已统一到 /pages/rewards —— 所有旧入口（商品页图标、
         顶部信用条 Share→、任何 data-bbr-open）一律跳新中心，不再弹旧面板 */
      if(t.closest('[data-bbr-open]')){ e.preventDefault(); location.href='/pages/rewards'; return; }
      if(t.id==='bbrScrim'){ closeSheet(); return; }
      if(t.id==='bbrCopy'||t.id==='bbrCopyBtn'||t.id==='bbrCopy3'){ e.preventDefault(); copyText(link()); return; }
      if(t.id==='bbrShareBtn'){
        var u=link();
        if(navigator.share){ navigator.share({ title:"beibelle74 fan art cards", text: MSG, url: u }).catch(function(){}); }
        else { copyText(MSG + '\n' + u); }
        return;
      }
      if(t.closest('[data-add-to-cart]')||t.closest('[data-buy-now]')) tagCart();
    }, true);

    function init(){
      st.anon = anon();
      captureRef();
      captureOp();
      // 朋友带着 ref 进来：先跳 /discount/FRIEND10 让 Shopify 落折扣 cookie，再回首页。
      // REGRESS-20261023 两处加固：
      //   ① 原来要求 URL 同时带 discount=FRIEND10 才跳 —— 分享链接被微信/短信截断掉
      //      后面半截时，朋友拿到的是「有 ref 但不减 10%」，等于承诺失效。
      //      改成「只要认到 ref、且 cookie 里还没有 FRIEND10」就补跳。
      //   ② 原来用 sessionStorage 一次性标记，第一次跳转被打断（弱网/后台标签页）
      //      就再也不重试。改成标记带时间戳，2 分钟内没落成就允许再来一次。
      try {
        var hasRef = !!st.ref;
        /* ONE-TRUTH-20261101：这一段现在只有一个作用 —— 让**订阅者**补落 10%（COLLECTOR5）。
           朋友不再因为"被邀请"获得额外折扣（他想要 10% 就自己订阅），
           所以 FRIEND10 / FRIEND15 / 15% 叠加那套已全部删除，别再按档位去推。 */
        /* 🔴 STAY-PUT-20261031（侯哥：「点邮件里的新卡按钮，一瞬间是新卡页，又跳主页」）
           原来这里写死往 '/' 回跳 —— 任何页面只要需要升档（订阅者补 5%、朋友升 15%），
           客户就被人从刚点进来的那一页踢回首页。邮件里标好的去处等于失效。
           现在原路返回：带着当前 path+query 一起回，落在哪就回哪。 */
        /* DISCOUNT-UNIFY-20261031：折扣统一为自动 10%，原先「按 ref / 订阅态升档到
           FRIEND10 / FRIEND15 / COLLECTOR5」的整段已删除。收益：
           ① 少一次整页跳转（原来每个被分享的新客都要白闪一次）；
           ② 不再有 RANK 表漏认 BB- 码、把分享人归属静默打掉的那类 bug；
           ③ FRIEND15（15%）那条毛利漏洞断根。 */
        void hasRef;
      } catch(e){}
      paint();
      /* STRIP-OFF-20261031：原本这里会给「带 ref 进来的人」弹一条顶部分享横幅，
         侯哥 21:28 截图圈掉（落地就要他分享，太急），已连同横幅本体一起删除。 */

      /* 🔴 THANKYOU-SHARE-20261023（侯哥：「下单后弹分享卡」）
         ------------------------------------------------------------------
         **平台限制**：Shopify Basic 的 thank_you / checkout 页注入不了主题 JS
         （checkout.liquid 对非 Plus 已关闭），所以「订单完成那一刻」在结账域名里做不到。
         等价实现：购物车从「有货」变「空车」＝ 极大概率刚下完单。
         ⚠️ 判定逻辑放在 brand.js 的 paintCart 里 —— 它本来就持有真实 cart 状态，
            **不需要**再为这件事多发一次 /cart.js（上一版在这里 fetch，实测每次进站多 1s）。
         这里只把 openSheet 暴露出去，给 brand.js 调用。 */
      window.BB_OPEN_SHARE = function (msg) {
        try { openSheet(); } catch (e) {}
        if (msg) { try { toast(msg); } catch (e) {} }
      };

      /* 登录完自动回推广中心：Shopify 若忽略了 return_url，客户会落到 /account
         或首页。这里用两个信号判定"刚从登录页回来"：一次性标记 + referrer 指向
         Shopify 登录域。只有同时满足才跳，避免打扰正常逛店（2026-10-29） */
      try {
        var pt = Number(ls('bb_pending_share') || 0);
        var fromAuth = /shopify\.com\/(authentication|accounts)/.test(document.referrer || '');
        var here = location.pathname;
        if (pt && Date.now() - pt < 15 * 60 * 1000 && fromAuth
            && here.indexOf('/pages/rewards') !== 0) {
          lss('bb_pending_share', '');
          location.replace('/pages/rewards?share=1');
          return;
        }
        if (pt && Date.now() - pt > 15 * 60 * 1000) lss('bb_pending_share', '');
      } catch (e) {}

      tagCart();
      setTimeout(tagCart, 1500);   // 兜底：首屏脚本被别的脚本挤掉时补一次
      balance();
      try { if(/[?&]share=1\b/.test(location.search)) setTimeout(openSheet, 300); } catch(e){}
    }
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
  
